import React, { useState, useRef, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import SweetAlert from "react-bootstrap-sweetalert";
import redirectURL from "../redirectURL";

export default function DelayCategoryMaster() {
    const gridRef = useRef();

    const decipher = (salt) => {
        const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
        const applySaltToChar = (code) => textToChars(salt).reduce((a, b) => a ^ b, code);
        return (encoded) =>
            (encoded || "")
                .match(/.{1,2}/g)
                ?.map((hex) => parseInt(hex, 16))
                .map(applySaltToChar)
                .map((charCode) => String.fromCharCode(charCode))
                .join("") || "";
    };
    const decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");

    const [rowData, setRowData] = useState([]);

    const [show, setShow] = useState(false);
    const [basicType, setBasicType] = useState("");
    const [basicTitle, setBasicTitle] = useState("");
    const [showloader, setshowloader] = useState("show-n");

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        setshowloader("show-m");
        try {
            const resp = await redirectURL.post("/consignments/getDelayCategories", {});

            if (resp?.data?.status === "success") {
                const rows = resp.data.records.map(r => ({
                    ...r,
                    _id: r._id?.toString() || null,
                    isDirty: false
                }));
                setRowData(rows);
            }
        } catch (err) {
            console.error("Load Error:", err);
            setRowData([]);
        }
        setshowloader("show-n"); 
    };


    const toCamelCase = (text) => {
        return text
            .toLowerCase()
            .replace(/\b\w/g, (c) => c.toUpperCase());
    };

    const isDuplicate = (category, ignoreIndex = null) => {
        return rowData.some((row, idx) =>
            idx !== ignoreIndex &&
            row.category?.toLowerCase() === category?.toLowerCase()
        );
    };

    const columnDefs = [
        {
            headerName: "",
            width: 130,
            editable: false,
            cellRenderer: (params) => {
                const d = params.data;

                const isValid =
                    d.category &&
                    d.description &&
                    !isDuplicate(d.category, params.rowIndex);

                const canSave = isValid && d.isDirty;

                return (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            width: "100%"
                        }}
                    >
                        <button
                            className="btn"
                            style={{
                                width: "70px",
                                height: "30px",
                                fontSize: "13px",
                                padding: "0px",
                                backgroundColor: canSave ? "#28a745" : "#ccc",
                                color: canSave ? "white" : "#666",
                                cursor: canSave ? "pointer" : "not-allowed",
                                border: "none",
                                borderRadius: "4px"
                            }}
                            disabled={!canSave}
                            onClick={() => saveRow(params)}
                        >
                            Save
                        </button>
                    </div>
                );

            }
        },
        {
            headerName: "Category",
            field: "category",
            editable: true,
            width: 250,
            valueSetter: (params) => {
                let newVal = params.newValue || "";
                newVal = toCamelCase(newVal);

                if (!newVal) return false;

                if (isDuplicate(newVal, params.rowIndex)) {
                    setBasicType("error");
                    setBasicTitle("Category already exists");
                    setShow(true);
                    return false;
                }

                params.data.category = newVal;
                params.data.isDirty = true;
                return true;
            }
        },
        {
            headerName: "Description",
            field: "description",
            editable: true,
            width: 400,
            valueSetter: (params) => {
                let val = params.newValue || "";
                val = toCamelCase(val);
                params.data.description = val;
                params.data.isDirty = true;
                return true;
            }
        }
    ];

    const defaultColDef = {
        resizable: true,
        sortable: true,
        filter: true,
        editable: true,
        singleClickEdit: true
    };

    const addRow = () => {
        setRowData((prev) => [
            ...prev,
            {
                _id: null,
                category: "",
                description: "",
                isDirty: true
            }
        ]);
    };
    const resetGrid = () => {
        setshowloader("show-m"); 
        loadData().finally(() => {
            gridRef.current.api.refreshCells({ force: true });
            setshowloader("show-n");
        });
    };

    const saveRow = async (params) => {
        setshowloader("show-m");
        const d = params.data;

        if (!d.category || !d.description) {
            setBasicType("error");
            setBasicTitle("Category & Description are required");
            setShow(true);
            setshowloader("show-n");
            return;
        }

        if (isDuplicate(d.category, params.rowIndex)) {
            setBasicType("error");
            setBasicTitle("Category already exists");
            setShow(true);
            return;
        }

        const payload = {
            record: {
                category: d.category,
                description: d.description
            },
            unique_id: d._id || null,
            email: decode(localStorage.getItem("email")) || "system",
            master_type: "DELAY_CATEGORY"
        };

        try {
            const resp = await redirectURL.post("/consignments/saveDelayCategory", payload);

            if (resp?.data?.status === "success") {

                if (!d._id && resp.data.inserted_id) {
                    params.data._id = resp.data.inserted_id;
                }

                params.data.isDirty = false;

                gridRef.current.api.applyTransaction({ update: [params.data] });
                gridRef.current.api.refreshCells({ force: true });

                setBasicType("success");
                setBasicTitle("Saved Successfully!");
                setShow(true);
                await loadData();

            } else {
                setBasicType("error");
                setBasicTitle(resp?.data?.message || "Save failed");
                setShow(true);
            }
        } catch {
            setBasicType("error");
            setBasicTitle("Server Error While Saving");
            setShow(true);
        }
    };


    return (
        <div className="container-fluid">
            <SweetAlert
                show={show}
                type={basicType}
                title={basicTitle}
                onConfirm={() => setShow(false)}
            />

            <div className="card">
                <div className="card-body">
                    <div className="mb-2 d-flex justify-content-end align-items-center">
                        <button
                            className="btn"
                            style={{
                                width: "100px",
                                height: "40px",
                                backgroundColor: "transparent",
                                color: "#555",
                                border: "1px solid #ccc",
                                borderRadius: "6px",
                                marginRight: "12px",
                                fontWeight: "500"
                            }}
                            onClick={resetGrid}
                        >
                            Reset
                        </button>
                        <button
                            className="btn"
                            style={{
                                width: "100px",
                                height: "40px",
                                backgroundColor: "#b084f7",
                                color: "white",
                                border: "none",
                                borderRadius: "6px"
                            }}
                            onClick={addRow}
                        >
                            + Add Row
                        </button>
                    </div>

                    <div className="ag-theme-balham" style={{ height: "480px", width: "100%" }}>
                        <AgGridReact
                            ref={gridRef}
                            rowData={rowData}
                            columnDefs={columnDefs}
                            defaultColDef={{
                                ...defaultColDef,
                                resizable: true,
                                sortable: true,
                                filter: true,
                                cellStyle: {
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: "14px"
                                }
                            }}
                            rowHeight={32}
                            pagination={true}
                            paginationPageSize={20}
                            sideBar={{
                                toolPanels: [
                                    {
                                        id: "columns",
                                        labelDefault: "Columns",
                                        iconKey: "columns",
                                        toolPanel: "agColumnsToolPanel"
                                    },
                                    {
                                        id: "filters",
                                        labelDefault: "Filters",
                                        iconKey: "filter",
                                        toolPanel: "agFiltersToolPanel"
                                    }
                                ],
                                position: "right",
                                defaultToolPanel: ""
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className={"dataLoadpage " + showloader}></div>
            <div className={"dataLoadpageimg " + showloader}>
                <div className="loader-box">
                    <div className="loader-box">
                        <div className="rotate dashed colored"></div>
                    </div>
                </div>
            </div>
        </div>
    );
} 